export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_HINT =
  'Минимум 6 символов, обязательно буквы и цифры';

export function validatePassword(password) {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_HINT;
  }
  if (!/[A-Za-zА-Яа-яЁё]/.test(password)) {
    return PASSWORD_HINT;
  }
  if (!/\d/.test(password)) {
    return PASSWORD_HINT;
  }
  return null;
}
